export enum CegidIntegrationStatus {
  Failed = 'rejected',
  Pending = 'not_started',
  Processing = 'processing',
  Posted = 'successful',
}
